module.exports = __webpack_public_path__ + "static/img/logo-TRACE.3192c70c.png";